import React from 'react';
import { useTheme } from '../../../../themes';

const CashPaymentsIcon = ({ className }: { className?: string }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7914 19.2292V10.3542C14.7914 9.53725 15.4536 8.875 16.2705 8.875H66.5622C67.3791 8.875 68.0414 9.53725 68.0414 10.3542V36.9792C68.0414 37.7961 67.3791 38.4583 66.5622 38.4583H29.583" />
        <path d="M68.053 19.2292L57.6988 8.875" />
        <path d="M14.8033 19.2292L25.1574 8.875" />
        <path d="M68.053 28.1041L57.6988 38.4583" />
        <path d="M11.8332 45.8541L18.5752 42.8396C19.936 41.9317 20.8602 40.501 21.1283 38.8872L22.1874 32.5416L31.302 26.0333C32.0808 25.4774 32.5426 24.5791 32.5415 23.6222V21.9478C32.5417 20.9859 32.0741 20.084 31.2879 19.5297C30.5018 18.9753 29.4952 18.8379 28.5892 19.1611L16.4482 23.501C13.4035 24.5891 10.5745 26.2054 8.0909 28.2757L2.95819 32.5416" />
        <path d="M2.95819 62.1251L9.59669 57.6876C11.0591 56.7175 12.7763 56.2027 14.5312 56.2084H35.4999" />
        <path d="M35.5 56.2084H43.7212C44.9951 56.2087 46.1261 55.3935 46.5287 54.1849L51.7708 38.4584" />
        <path d="M48.8238 47.3334H35.5113" />
        <path d="M38.4582 47.3334C36.0074 47.3334 34.0207 45.3466 34.0207 42.8959C34.0207 40.4451 36.0074 38.4584 38.4582 38.4584" />
        <path d="M35.5 56.2084C33.0492 56.2084 31.0625 54.2216 31.0625 51.7709C31.0625 49.3201 33.0492 47.3334 35.5 47.3334" />
        <g stroke={theme.colors.dashboardAccent}>
          <path d="M44.3863 29.5834V32.5417" />
          <path d="M44.3863 14.7916V17.75" />
          <path d="M38.4582 29.5833H47.3332C48.967 29.5833 50.2915 28.2588 50.2915 26.625C50.2915 24.9912 48.967 23.6667 47.3332 23.6667H41.4165C39.7827 23.6667 38.4582 22.3422 38.4582 20.7083C38.4582 19.0745 39.7827 17.75 41.4165 17.75H50.2915" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CashPaymentsIcon;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundSelectionPage/CashPaymentsIcon.tsx